import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=a7dbe818&scoped=true&"
import script from "./SidebarHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarHeader.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=a7dbe818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dbe818",
  null
  
)

export default component.exports